<app-template [disablebreadcrumb]=true
              [fullLayout]="true"
              [footerVisible]="true">
  <div class="participations">
    <div class="search-container">
      <div class="search-area">
        <div class="search-button" [@rotatedState]='state' [@hide]='hide' (click)="search()">Pesquisar</div>
        <input [@rotatedState]='state' [(ngModel)]="textSearch" (keydown.enter)="search()"  minlength="3">
        <div class="action-icon" (click)="showHide();">
          <div [innerHTML]="colorService.svgList[searchSvg].htmlText" class="search-svg"></div>
        </div>
      </div>
      <div class="{{classMsg}}" *ngIf="showMessage">
        <div class="message" [ngStyle]="{'background-color': wasFound ? '#316b31' : '#a83838'}">
          <strong>{{searchMessage}}</strong>
          <div class="close" (click)="closeMessage()" >x</div>
        </div>
      </div>
    </div>
    <div class="title-container">
      <div class="title">Minhas Participações</div>
      <div *ngIf="false" class="subtitle">Subtítulo</div>
    </div>
    <div class="participations-list">
      <div class="p-grid timeline">
        <div *ngIf="listParticipations.length === 0" class="no-participation-msg">Nenhum destaque ou proposta</div>
        <div class="p-col-12 line" *ngFor="let participation of listParticipations; let i = index;">
          <div class="link-line">
            <div class="vertical-line top" [class.hidden]="!i"></div>
            <div class="bg-icon">
              <div class="svg-line" [innerHTML]="participation.highlight ? colorService.svgList.check_circle2_svg.htmlText : colorService.svgList.logomark_white2_svg.htmlText" alt="Ìcone item da timeline" ></div>
            </div>
            <div class="vertical-line bottom" [class.hidden]="listParticipations?.length === (i + 1)"></div>
          </div>
          <ng-container *ngIf="participation.highlight; else proposal">
            <div class="highlight">
              <div class="top">
                <span class="title">DESTAQUE</span>
              </div>
              <div class="plan-items">
                <div class="item" *ngIf="regionalization">
                  <div class="structure-item">
                    <div [innerHTML]="colorService.svgList.locality_without_map_gradient_svg.htmlText" class="structure-img"></div>
                    <div class="name">{{ participation.localityDto?.type?.name}}</div>
                  </div>
                  <div class="name">{{ participation.localityDto?.name }}</div>
                </div>
                <div class="item" *ngFor="let item of participation.planItems; last as isLast">
                  <div class="structure-item">
                    <div *ngIf="!isLast" [innerHTML]="colorService.svgList.area_tematica_svg.htmlText" class="structure-img"></div>
                    <div *ngIf="isLast" [innerHTML]="colorService.svgList.desafio_svg.htmlText" class="structure-img"></div>
                    <div class="name">{{ item.structureItemName }}</div>
                  </div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #proposal>
            <div class="item-timeline">
              <div class="comment">
                <div class="top">
                  <span class="status">
                    <div [innerHTML]="colorService.svgList.quote2_svg.htmlText" class="quote-svg"></div>
                    PROPOSTA
                  </span>
                </div>
                <p class="text" style="font-size: 18px;">{{ participation.text }}</p>

                <a class="likes" [class.has-like]="!!participation.qtdLiked" style="font-size: 12px; display: inline-block;">
                  <span style="display: inline-block;">
                      {{ participation.qtdLiked || 0 }}
                  </span>
                  <span style="display: inline-block;">
                      <div [innerHTML]="colorService.svgList.like2_svg.htmlText" class="like-svg"></div>
                  </span>
              </a>
              </div>
              <div class="info-plan">
                <div class="item" *ngIf="regionalization">
                  <div class="structure-item">
                    <div [innerHTML]="colorService.svgList.locality_without_map_gradient_svg.htmlText" class="structure-img"></div>
                    <div class="name">{{ participation.localityDto?.type?.name}}</div>
                  </div>
                  <div class="name">{{ participation.localityDto?.name }}</div>
                </div>
                <div class="item" *ngFor="let item of participation.planItems; let i = index; last as isLast"
                  [ngStyle]="{ order: item.structureItemName === 'Área Estratégica' ? ( i === 0 ? 2 : 1 ) : i }">
                  <div class="structure-item">
                    <div *ngIf="!isLast" [innerHTML]="colorService.svgList.area_tematica_svg.htmlText" class="structure-img"></div>
                    <div *ngIf="isLast" [innerHTML]="colorService.svgList.desafio_svg.htmlText" class="structure-img"></div>
                    <div class="name">{{ item.structureItemName }}</div>
                  </div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <app-modal class="modal-comment" [show]="showModalProposal" (onCallback)="modalOnCallback($event)">
    <h2>{{ selectedParticipation?.planItems[0].name }}</h2>
    <p>{{ selectedParticipation?.planItems[0].description }}</p>
    <textarea [maxlength]="200" rows="6" [(ngModel)]="newProposal"></textarea>
    <span class="count-characters">Caracteres restantes {{ newProposal.length || 0 }}/200</span>
  </app-modal>
</app-template>
